import RequestAPI from '@/services/RequestAPI'

import { GRANT_TYPE } from '@/services/ApiService.const'

const connect = async (type, username, password) => {
  return await RequestAPI.requestToken({
    grant_type: GRANT_TYPE[type],
    username: username,
    password: password,
  })
}

const connectToken = async (token) => {
  return await RequestAPI.connectToken({
    token: token,
  })
}

const logout = async (token) => {
  return await RequestAPI.logout({
    token: token,
  })
}

const getPeople = async (ids) => {
  const list = []
  for (const id of ids) {
    const response = await RequestAPI.getPerson({ id, })
    list.push(response.data)
  }

  return list
}

const getPerson = async (id) => {
  const response = await RequestAPI.getPerson({ id, })

  return response
}

const getPersonControls = async (id) => {
  const response = await RequestAPI.getPersonControls({ id, })

  return response
}

const getPeopleList = async (params) => {
  const response = await RequestAPI.getPeopleList(params)

  return response
}

const getCustomerFile = async (id) => {
  const response = await RequestAPI.getCustomerFile({ id, })

  return response
}

const getConfiguration = async () => {
  const response = await RequestAPI.getConfiguration()

  return response
}

const updatePerson = async (id, payload) => {
  return await RequestAPI._patchItem('people', id, payload)
}

const validatePersonFolder = async (id) => {
  return await RequestAPI.validatePersonFolder(id)
  // return await RequestAPI.validatePersonFolder('customer_files', id)
}

const createDocument = async (payload) => {
  return await RequestAPI.createDocument(payload)
}

const deleteDocument = async (id) => {
  return await RequestAPI.deleteDocument(id)
}

const addPages = async (payload) => {
  return await RequestAPI.addPages(payload)
}

const deletePage = async (idDoc, idPages) => {
  return await RequestAPI.deletePage(idDoc, idPages)
}

const downloadPage = async (idPage) => {
  return await RequestAPI.downloadPage(idPage)
}

const updateDocumentAttribute = async (id, payload) => {
  return await RequestAPI._patchItem('supporting_documents', id, payload)
}

const updateAdvisorCheck = async (id, payload) => {
  return await RequestAPI._patchItem('person_controls', id, payload)
}

const getTimeline = async (id) => {
  const response = await RequestAPI.getTimeline({ id, })

  return response
}

const generateReport = async (email) => {
  const response = await RequestAPI.generateReport(email)

  return response
}

const ApiService = {
  getPeople,
  getPerson,
  getPersonControls,
  getCustomerFile,
  getConfiguration,
  connect,
  connectToken,
  logout,
  updatePerson,
  createDocument,
  deleteDocument,
  addPages,
  deletePage,
  downloadPage,
  updateDocumentAttribute,
  validatePersonFolder,
  updateAdvisorCheck,
  getTimeline,
  getPeopleList,
  generateReport,
}

export default ApiService
